import React from 'react';

import NavbarSvg from './NavbarSvg.jsx';
import classes from '../FitnessPreview.module.scss';



const TopNavbar = () => {
    return (
        <div className={classes.topNavbar} >
            <NavbarSvg/>
        </div>
    )
}

export default TopNavbar;